// import { Box, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
// import { BsDot } from 'react-icons/bs';
// import Map from '../../../components/mapView/mapView';
// import CopyButton from '../../../components/copyButton';
// import CustomTabs from '../../../components/customTabs/customTabs';

// const ViewResponse = ({ data }) => {
//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const datax = [
//     {
//       title: "Image",
//       render: (
//         <Box
//           height={"250px"}
//           onClick={onOpen}
//           cursor={"pointer"}
//           borderRadius={"4px"}
//           backgroundImage={data?.entries?.find(i => i?.answer?.includes('cloudinary'))?.answer}
//           backgroundSize={"cover"}
//         ></Box>
//       ),
//     },
//     {
//       title: "Map View",
//       render: <Map coordinates={data?.location?.coordinates} height={"250px"} />,
//     },
//   ];

//   const { entries, survey } = data || {};
//   const { questions } = survey || {};

//   const groupedResponses = {};

//   // ** Grouping parent and child questions together **
//   entries.forEach(entry => {
//     const { questionIndex, answer } = entry;
//     const parentIndex = Math.floor(questionIndex); // Get main parent index (e.g., 1.1 → 1)

//     if (!groupedResponses[parentIndex]) {
//       groupedResponses[parentIndex] = {
//         parent: questions[parentIndex],
//         responses: []
//       };
//     }

//     if (!questionIndex.includes(".")) {
//       // if questionIndex is an integer after converting from string, then else
//       groupedResponses[parentIndex].responses.unshift({
//         title: groupedResponses[parentIndex].parent?.title || groupedResponses[parentIndex].parent?.fieldName,
//         value: answer,
//         isParent: true
//       });
//     } else {
//       // Child Question (e.g., "1.1", "1.2")
//       const array = questionIndex.split('.')
//       const parent = array[0]
//       const child = array[1]

//       const parentQuestion = questions[parent];
//       console.log(parentQuestion)
//       const childQuestion = parentQuestion?.childrenCategories?.map(cat => cat.questions)?.find(q => q._id === entry._id);

//       console.log(childQuestion)
//       console.log(groupedResponses[parent])
//       groupedResponses[parentIndex].responses.push({
//         // title: childQuestion?.question || `Sub-question ${questionIndex}`,
//         // title: groupedResponses[parent].parent?.title || groupedResponses[parentIndex].parent?.fieldName,
//         value: answer,
//         isParent: false
//       });
//     }
//   });

//   const handleDownload = async () => {
//     const imageUrl = data?.entries?.find(i => i?.answer?.includes('cloudinary'))?.answer;

//     try {
//       const response = await fetch(imageUrl);
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);

//       const link = document.createElement('a');
//       link.href = url;
//       link.download = 'survey_submission_image.jpg';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Release the object URL
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error('Error downloading image:', error);
//     }
//   };

//   return (
//     <Box>
//       <CustomTabs data={datax} />
//       <Box mt="1rem">
//         {Object.values(groupedResponses).map(({ parent, responses }, index) => (
//           <Box key={index} mb="1rem">
//             {responses.map(({ title, value, isParent }, idx) => (
//               <Flex key={idx} mb=".8rem" alignItems={"center"} justifyContent={"space-between"}>
//                 <Flex alignItems={"center"} gap="1rem">
//                   <BsDot color='#98A2B3' />
//                   <Box>
//                     <Text
//                       mb=".1rem"
//                       color={isParent ? "#344054" : "#475467"}
//                       fontSize={".8rem"}
//                       fontWeight={"500"}
//                       textTransform={"capitalize"}
//                     >
//                       {title}
//                     </Text>
//                     <Text color={"#101928"} fontSize={".9rem"} fontWeight={"500"}>{value}</Text>
//                   </Box>
//                 </Flex>
//                 {title === "Store ID" && <CopyButton toCopy={value} />}
//               </Flex>
//             ))}
//           </Box>
//         ))}
//       </Box>

//       <Modal size={"6xl"} isCentered motionPreset="slideInBottom" isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader fontSize={"1rem"} textTransform={"capitalize"}>{'Image'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Box
//               cursor={"pointer"}
//               onClick={handleDownload}
//               height={"68vh"}
//               borderRadius={"4px"}
//               width={"100%"}
//               backgroundImage={data?.entries?.find((i) => i?.answer?.includes('cloudinary'))?.answer}
//               backgroundSize={"contain"}
//               backgroundPosition={"center"}
//               backgroundRepeat={"no-repeat"}
//             />
//             <Text pb="1rem" mt="2rem" textAlign={"center"} fontSize={".9rem"} fontWeight={"500"} cursor={"pointer"} onClick={onClose}>
//               Close
//             </Text>
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default ViewResponse;


import { Box, Text, VStack } from '@chakra-ui/react';

const ViewResponse = ({ data: responseData }) => {

  const { survey } = responseData || {};
  const { questions } = survey || {};

  console.log(responseData)

  const mapQuestionsToIndices = (questions) => {
    const questionMap = {};

    questions.forEach((question, parentIndex) => {
      // Map parent question
      questionMap[parentIndex] = {
        title: question.title,
        children: {},
      };

      // Map child questions if the question has childrenCategories
      if (question.fieldType === "children" && question.childrenCategories) {
        question.childrenCategories.forEach((category, categoryIndex) => {
          category.questions.forEach((childQuestion, childIndex) => {
            const fullIndex = `${parentIndex}.${childIndex}`;
            questionMap[parentIndex].children[fullIndex] = {
              title: childQuestion.question,
            };
          });
        });
      }
    });

    return questionMap;
  };

  const isImageUrl = (url) => {
    return url.startsWith('https://res.cloudinary.com');
  };

  const parseResponseData = (entries, questionMap, questions) => {
    const parsedData = {};

    entries.forEach((entry) => {
      const { questionIndex, answer } = entry;
      const parts = questionIndex;

      if (parts.length === 1) {
        // Parent question
        const parentIndex = parts[0];
        const parentQuestion = questions[parentIndex];

        parsedData[parentIndex] = {
          question: parentQuestion.title, // Add actual question text
          answer,
          children: [],
        };

        // If the parent question is a radio selection, find the selected category
        if (parentQuestion.fieldType === "children") {
          const selectedCategory = parentQuestion.childrenCategories.find(
            (cat) => cat.title === answer
          );

          if (selectedCategory) {
            // Add child questions for the selected category
            selectedCategory.questions.forEach((childQuestion, childIndex) => {
              const fullIndex = `${parentIndex}.${childIndex}`;
              parsedData[parentIndex].children.push({
                question: childQuestion.question,
                answer: entries.find((e) => e.questionIndex === fullIndex)?.answer || "No answer",
              });
            });
          }
        }
      }
    });

    return parsedData;
  };


  if (!responseData) return <Text>No response data found.</Text>;

  // Map questions to their indices
  const questionMap = mapQuestionsToIndices(questions);

  // Parse the response data
  const parsedData = parseResponseData(responseData.entries, questionMap, questions);

  return (
    <Box p={4}>
      <Text fontSize="2xl" fontWeight="bold" mb={4}>
        Response Details
      </Text>
      <VStack align="start" spacing={4}>
        {Object.keys(parsedData).map((parentIndex) => (
          <Box key={parentIndex} p={4} borderWidth="1px" borderRadius="lg" w="100%">
            <Text fontWeight="bold">{parsedData[parentIndex].question}</Text>
            {isImageUrl(parsedData[parentIndex].answer) ? (
              <img
                src={parsedData[parentIndex].answer}
                alt="Response Image"
                style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
              />
            ) : (
              <Text>{parsedData[parentIndex].answer}</Text>
            )}

            {/* Render child questions */}
            {parsedData[parentIndex].children.length > 0 && (
              <VStack align="start" pl={4} mt={2} spacing={2}>
                {parsedData[parentIndex].children.map((child, idx) => (
                  <Box key={idx} pl={4} borderLeftWidth="2px" borderColor="gray.200">
                    <Text fontWeight="bold">{child.question}</Text>
                    {isImageUrl(child.answer) ? (
                      <img
                        src={child.answer}
                        alt="Response"
                        style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                      />
                    ) : (
                      <Text>{child.answer}</Text>
                    )}
                  </Box>
                ))}
              </VStack>
            )}
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default ViewResponse;